export default function extract(event) {
  return event.data;
}